<template>
  <el-form
    :model="accountForm"
    status-icon
    :rules="rules"
    ref="billingDetailsForm"
  >
    <el-row class="layout__padding-0-50px d-flex align-center">
      <el-col
        :span="4"
        class="layout__padding__right-20px"
      >
        <div>
          Main Contact
        </div>
      </el-col>

      <el-col
        :span="8"
        class="layout__padding__right-20px"
      >
        <el-checkbox
          class="layout__border__bottom-none text__direction-left-to-right p-0"
          @change="setMainContact"
        >
          <span class="layout__padding__left-20px font-12-required">
            Are you the main contact?
          </span>
        </el-checkbox>
      </el-col>

      <el-col
        :span="4"
        class="layout__padding__right-20px"
      >
        <div>
          Accounts contact
        </div>
      </el-col>

      <el-col
        :span="8"
        class="layout__padding__right-20px"
      >
        <el-checkbox
          class="layout__border__bottom-none text__direction-left-to-right p-0"
          @change="setAccountsContact"
        >
          <span class="layout__padding__left-20px font-12-required">
            Are you the accounts contact?
          </span>
        </el-checkbox>
      </el-col>
    </el-row>

    <el-row class="layout__padding-0-50px">
      <el-col
        :span="4"
        class="layout__padding__right-20px"
      >
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        >
          First name
        </div>
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        >
          Surname
        </div>
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        >
          Telephone
        </div>
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        >
          Email
        </div>
      </el-col>

      <el-col
        :span="8"
        class="layout__padding__right-20px"
      >
        <el-form-item
          prop="main_contact_firstname"
        >
          <el-input
            class=""
            placeholder="First name"
            v-model="accountForm.main_contact_firstname"
          />
        </el-form-item>
        <el-form-item
          prop="main_contact_surname"
        >
          <el-input
            class=""
            placeholder="Surname"
            v-model="accountForm.main_contact_surname"
          />
        </el-form-item>
        <el-form-item
          prop="main_contact_telephone"
        >
          <el-input
            class=""
            placeholder="Telephone"
            v-model="accountForm.main_contact_telephone"
          />
        </el-form-item>
        <el-form-item
          prop="main_contact_email"
        >
          <el-input
            class=""
            placeholder="Email"
            v-model="accountForm.main_contact_email"
          />
        </el-form-item>
      </el-col>

      <el-col
        :span="4"
        class="layout__padding__right-20px"
      >
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        >
          First name
        </div>
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        >
          Surname
        </div>
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        >
          Telephone
        </div>
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        >
          Email
        </div>
      </el-col>

      <el-col
        :span="8"
        class="layout__padding__right-20px"
      >
        <el-form-item
          prop="accounts_contact_name"
        >
          <el-input
            class=""
            placeholder="First name"
            v-model="accountForm.accounts_contact_name"
          />
        </el-form-item>
        <el-form-item
          prop="accounts_contact_surname"
        >
          <el-input
            class=""
            placeholder="Surname"
            v-model="accountForm.accounts_contact_surname"
          />
        </el-form-item>
        <el-form-item
          prop="accounts_contact_telephone"
        >
          <el-input
            class=""
            placeholder="Telephone"
            v-model="accountForm.accounts_contact_telephone"
          />
        </el-form-item>
        <el-form-item
          prop="accounts_contact_email"
        >
          <el-input
            class=""
            placeholder="Email"
            v-model="accountForm.accounts_contact_email"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <el-row class="layout__padding-0-50px d-flex align-center">
      <el-col
        :span="4"
        class="layout__padding__right-20px"
      >
        <div>
          Invoice address
        </div>
      </el-col>

      <el-col
        :span="8"
        class="layout__padding__right-20px"
      >
        <el-checkbox
          class="layout__border__bottom-none text__direction-left-to-right p-0"
          @change="setInvoiceAddress"
        >
          <span class="layout__padding__left-20px font-12-required">
            Is your Invoice address the same as delivery address?
          </span>
        </el-checkbox>
      </el-col>

      <el-col
        :span="4"
        class="layout__padding__right-20px"
      >
        <div>
          Payment options
        </div>
      </el-col>
    </el-row>

    <el-row class="layout__padding-0-50px">
      <el-col
        :span="4"
        class="layout__padding__right-20px"
      >
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        >
          Address 1
        </div>
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        >
          Address 2
        </div>
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        >
          Town
        </div>
        <div
          class="text__colour-teal layout__padding-5-0 layout__height-35px font-12-required"
        >
          Postcode
        </div>
      </el-col>

      <el-col
        :span="8"
        class="layout__padding__right-20px"
      >
        <el-form-item
          prop="billing_address1"
        >
          <el-input
            class=""
            placeholder="Address 1"
            v-model="accountForm.billing_address1"
          />
        </el-form-item>
        <el-form-item
          prop="billing_address2"
        >
          <el-input
            class=""
            placeholder="Address 2"
            v-model="accountForm.billing_address2"
          />
        </el-form-item>
        <el-form-item
          prop="billing_town"
        >
          <el-input
            class=""
            placeholder="Town"
            v-model="accountForm.billing_town"
          />
        </el-form-item>
        <el-form-item
          prop="billing_postcode"
        >
          <el-input
            class=""
            placeholder="Postcode"
            v-model="accountForm.billing_postcode"
          />
        </el-form-item>
      </el-col>

      <el-col
        :span="12"
      >
        <p>
          Registering with us will allow you to pay by card, if you would also like to pay using a credit account please
          tick the box below
        </p>

        <el-form-item
          prop="is_account_payment_requested"
        >
          <el-checkbox
            v-model="accountForm.is_account_payment_requested"
            class="layout__border__bottom-none text__direction-left-to-right p-0"
          >
            <span class="layout__padding__left-20px font-12-required">
              I want a credit account
            </span>
          </el-checkbox>
        </el-form-item>

        <el-form-item
          v-if="accountForm.is_account_payment_requested"
          prop="company_registration_number"
        >
          <el-input
            class=""
            placeholder="Company Registration Number"
            v-model="accountForm.company_registration_number"
          />
        </el-form-item>
      </el-col>
    </el-row>

    <div class="d-flex justify-center">
      <el-button
        class="button__background-tickled-pink layout__width-150px"
        @click="next"
      >
        Finish
      </el-button>
    </div>
  </el-form>
</template>

<script>
export default {
  name: 'BillingDetails',

  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },

    finalForm: {
      type: Object,
      required: true,
    },
  },

  data() {
    const checkCompanyRegNumber = (rule, value, callback) => {
      if (!value && this.accountForm.is_account_payment_requested) {
        return callback(new Error('Company Registration Number required'));
      }

      callback();
    };

    return {
      same: false,
      accountForm: {
        main_contact_firstname: '',
        main_contact_surname: '',
        main_contact_telephone: '',
        main_contact_email: '',
        accounts_contact_name: '',
        accounts_contact_surname: '',
        accounts_contact_telephone: '',
        accounts_contact_email: '',
        billing_address1: '',
        billing_address2: '',
        billing_town: '',
        billing_postcode: '',
        is_account_payment_requested: false,
        company_registration_number: '',
      },
      rules: {
        main_contact_firstname: [
          { required: true, message: 'First name required', trigger: 'blur' },
        ],
        main_contact_surname: [
          { required: true, message: 'Surname required', trigger: 'blur' },
        ],
        main_contact_telephone: [
          { required: true, message: 'Telephone required', trigger: 'blur' },
          {
            required: true,
            pattern: /^[0-9, ]*$/,
            message: 'Telephone invalid',
            trigger: 'blur',
          },
        ],
        main_contact_email: [
          { required: true, message: 'Email required', trigger: 'blur' },
          {
            required: true,
            pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: 'Email invalid',
            trigger: 'blur',
          },
        ],
        accounts_contact_name: [
          { required: true, message: 'First name required', trigger: 'blur' },
        ],
        accounts_contact_surname: [
          { required: true, message: 'Surname required', trigger: 'blur' },
        ],
        accounts_contact_telephone: [
          { required: true, message: 'Telephone required', trigger: 'blur' },
          {
            required: true,
            pattern: /^[0-9, ]*$/,
            message: 'Telephone invalid',
            trigger: 'blur',
          },
        ],
        accounts_contact_email: [
          { required: true, message: 'Email required', trigger: 'blur' },
          {
            required: true,
            pattern: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            message: 'Email invalid',
            trigger: 'blur',
          },
        ],
        billing_address1: [
          { required: true, message: 'Invoice address 1 required', trigger: 'blur' },
        ],
        billing_town: [
          { required: true, message: 'Town required', trigger: 'blur' },
        ],
        billing_postcode: [
          { required: true, message: 'Postcode required', trigger: 'blur' },
        ],
        company_registration_number: [
          {
            validator: checkCompanyRegNumber,
            trigger: 'blur',
          },
        ],
      },
    };
  },

  methods: {
    next() {
      this.$refs.billingDetailsForm.validate((valid) => {
        if (!valid || this.isLoading) {
          return;
        }

        this.$emit('step-passed', {
          userData: this.accountForm,
          saveUser: true,
          finishRegistration: true,
          nextStep: '',
        });
      });
    },

    setMainContact(val) {
      if (val) {
        this.accountForm.main_contact_firstname = this.finalForm.firstName;
        this.accountForm.main_contact_surname = this.finalForm.surname;
        this.accountForm.main_contact_telephone = this.finalForm.telephone;
        this.accountForm.main_contact_email = this.finalForm.email;
      }
    },

    setAccountsContact(val) {
      if (val) {
        this.accountForm.accounts_contact_name = this.finalForm.firstName;
        this.accountForm.accounts_contact_surname = this.finalForm.surname;
        this.accountForm.accounts_contact_telephone = this.finalForm.telephone;
        this.accountForm.accounts_contact_email = this.finalForm.email;
      }
    },

    setInvoiceAddress(val) {
      if (val) {
        this.accountForm.billing_address1 = this.finalForm.branch_address1;
        this.accountForm.billing_address2 = this.finalForm.branch_address2;
        this.accountForm.billing_town = this.finalForm.branch_town;
        this.accountForm.billing_postcode = this.finalForm.branch_postcode;
      }
    },
  },
};
</script>